import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function Home({ ...props }) {
  const history = useHistory();

  useEffect(() => {
    let level = parseInt(localStorage.getItem("user_level"), 10);

    if (!isNullOrEmpty(level)) {
      if (level === 1 || level === 2 || level === 3) {
        history.push("/hospitals");
      } else {
        history.push("/wards");
      }
    } else {
      history.push("/login");
    }
  }, []);

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  return <></>;
}
